if (!customElements.get('aquatix-gallery')) {
  class AquatixGallery extends HTMLElement {
    connectedCallback() {
      this._reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      this._motionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
      this._motionQuery.addEventListener('change', this._onMotionChange.bind(this));

      if (this._reducedMotion) {
        this._pauseAllVideos();
      }
    }

    disconnectedCallback() {
      this._motionQuery.removeEventListener('change', this._onMotionChange.bind(this));
    }

    _onMotionChange(e) {
      this._reducedMotion = e.matches;
      if (this._reducedMotion) {
        this._pauseAllVideos();
      } else {
        this._playAllVideos();
      }
    }

    _pauseAllVideos() {
      this.querySelectorAll('.aquatix-gallery__video').forEach(video => {
        video.pause();
        video.removeAttribute('autoplay');
      });
    }

    _playAllVideos() {
      this.querySelectorAll('.aquatix-gallery__video').forEach(video => {
        video.setAttribute('autoplay', '');
        video.play().catch(() => {});
      });
    }
  }

  customElements.define('aquatix-gallery', AquatixGallery);
}
